import React from 'react';

import {
  Box,
  Button,
  styled,
  Typography as BaseTypography
} from '@mui/material';
import {
  BaseSnackbar,
  beginSubscriptionDataService,
  imageUtil,
  ResponsiveImage
} from 'modules';



const imgs = imageUtil.getUrlSet('download', 'png');



const MessageBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column'
});

const Typography = styled(BaseTypography)(({ theme }) => ({
  color: 'white !important',
  maxWidth: 257,
  marginLeft: theme.spacing(3),
  fontSize: 16
}));

const StyledSpan = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main
}));


export interface IProps {
  subscriptionStatus?: string;
  totalDownloads: number;
  currentDownloads: number;

  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {
  const { fnEndTrialEarlyMutate, endTrialEarlyMutateLoading } = beginSubscriptionDataService.useBeginSubscriptionQuery();



  function __renderUsagePassage() {
    return (
      <Typography>
        You've downloaded
        <StyledSpan>&nbsp;{props.currentDownloads}&nbsp;</StyledSpan>
        out of {props.totalDownloads} slides&nbsp;
        {props.subscriptionStatus === 'trialing'
          ? 'allowed in your free trial.'
          : 'allowed per month.'}
      </Typography>
    );
  }

  return (
    <BaseSnackbar.FC onClose={props.onClose}>
      <ResponsiveImage.FC urlSet={imgs} />

      <MessageBox>
        {__renderUsagePassage()}

        {props.subscriptionStatus === 'trialing' && (
          <Typography>
            <Button
              onClick={async () => {
                await fnEndTrialEarlyMutate();
                props.onClose();
              }}
              disabled={endTrialEarlyMutateLoading}>
              Begin Annual Subscription
            </Button>
            &nbsp;
            to access more Ridge materials now.
          </Typography>
        )}
      </MessageBox>
    </BaseSnackbar.FC>
  );
};
